<div class="container-fluid main">
  <section>
    <div class="row main-content">
      <div class="col-md-6">
        <div style="margin-top: -5rem">
          <span class="placeholder">I am </span>
          <span class="typed-element"></span>
          <span class="typed-cursor">|</span>
          <p class="separator"></p>
        </div>

        <div class="row my-3">
          <div class="col-md-12">
            <span class="placeholder-secondary"
              >Tech Enthusiast | Full Stack Dev | Problem Solver</span
            >
          </div>
        </div>

        <div style="margin-top: 10rem">
          <a href="mailto:rohit.rana0207@gmail.com">
            <button class="btn btn-hire mx-3">HIRE ME</button>
          </a>

          <a [href]="hLink.gitHubLink" target="_blank">
            <button class="btn btn-utility">MY WORKS</button>
          </a>
        </div>
        <div class="row home-social-icons">
          <div class="col-md-12">
            <app-footer [isCopyrightContent]="false"></app-footer>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
